/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as GraphDefs from '../graph/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'
import * as NotificationDefs from '../notification/defs.defs.js'
import * as FeedThreadgate from '../feed/threadgate.defs.js'
import * as FeedPostgate from '../feed/postgate.defs.js'
import * as EmbedExternal from '../embed/external.defs.js'

const $nsid = 'app.bsky.actor.defs'

export { $nsid }

type ProfileViewBasic = {
  $type?: 'app.bsky.actor.defs#profileViewBasic'
  did: l.DidString
  handle: l.HandleString
  displayName?: string
  pronouns?: string
  avatar?: l.UriString
  associated?: ProfileAssociated
  viewer?: ViewerState
  labels?: LabelDefs.Label[]
  createdAt?: l.DatetimeString
  verification?: VerificationState
  status?: StatusView

  /**
   * Debug information for internal development
   */
  debug?: l.LexMap
}

export type { ProfileViewBasic }

const profileViewBasic = l.typedObject<ProfileViewBasic>(
  $nsid,
  'profileViewBasic',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    displayName: l.optional(l.string({ maxGraphemes: 64, maxLength: 640 })),
    pronouns: l.optional(l.string()),
    avatar: l.optional(l.string({ format: 'uri' })),
    associated: l.optional(
      l.ref<ProfileAssociated>((() => profileAssociated) as any),
    ),
    viewer: l.optional(l.ref<ViewerState>((() => viewerState) as any)),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    verification: l.optional(
      l.ref<VerificationState>((() => verificationState) as any),
    ),
    status: l.optional(l.ref<StatusView>((() => statusView) as any)),
    debug: l.optional(l.lexMap()),
  }),
)

export { profileViewBasic }

type ProfileView = {
  $type?: 'app.bsky.actor.defs#profileView'
  did: l.DidString
  handle: l.HandleString
  displayName?: string
  pronouns?: string
  description?: string
  avatar?: l.UriString
  associated?: ProfileAssociated
  indexedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  viewer?: ViewerState
  labels?: LabelDefs.Label[]
  verification?: VerificationState
  status?: StatusView

  /**
   * Debug information for internal development
   */
  debug?: l.LexMap
}

export type { ProfileView }

const profileView = l.typedObject<ProfileView>(
  $nsid,
  'profileView',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    displayName: l.optional(l.string({ maxGraphemes: 64, maxLength: 640 })),
    pronouns: l.optional(l.string()),
    description: l.optional(l.string({ maxGraphemes: 256, maxLength: 2560 })),
    avatar: l.optional(l.string({ format: 'uri' })),
    associated: l.optional(
      l.ref<ProfileAssociated>((() => profileAssociated) as any),
    ),
    indexedAt: l.optional(l.string({ format: 'datetime' })),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    viewer: l.optional(l.ref<ViewerState>((() => viewerState) as any)),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    verification: l.optional(
      l.ref<VerificationState>((() => verificationState) as any),
    ),
    status: l.optional(l.ref<StatusView>((() => statusView) as any)),
    debug: l.optional(l.lexMap()),
  }),
)

export { profileView }

type ProfileViewDetailed = {
  $type?: 'app.bsky.actor.defs#profileViewDetailed'
  did: l.DidString
  handle: l.HandleString
  displayName?: string
  description?: string
  pronouns?: string
  website?: l.UriString
  avatar?: l.UriString
  banner?: l.UriString
  followersCount?: number
  followsCount?: number
  postsCount?: number
  associated?: ProfileAssociated
  joinedViaStarterPack?: GraphDefs.StarterPackViewBasic
  indexedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  viewer?: ViewerState
  labels?: LabelDefs.Label[]
  pinnedPost?: RepoStrongRef.Main
  verification?: VerificationState
  status?: StatusView

  /**
   * Debug information for internal development
   */
  debug?: l.LexMap
}

export type { ProfileViewDetailed }

const profileViewDetailed = l.typedObject<ProfileViewDetailed>(
  $nsid,
  'profileViewDetailed',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    displayName: l.optional(l.string({ maxGraphemes: 64, maxLength: 640 })),
    description: l.optional(l.string({ maxGraphemes: 256, maxLength: 2560 })),
    pronouns: l.optional(l.string()),
    website: l.optional(l.string({ format: 'uri' })),
    avatar: l.optional(l.string({ format: 'uri' })),
    banner: l.optional(l.string({ format: 'uri' })),
    followersCount: l.optional(l.integer()),
    followsCount: l.optional(l.integer()),
    postsCount: l.optional(l.integer()),
    associated: l.optional(
      l.ref<ProfileAssociated>((() => profileAssociated) as any),
    ),
    joinedViaStarterPack: l.optional(
      l.ref<GraphDefs.StarterPackViewBasic>(
        (() => GraphDefs.starterPackViewBasic) as any,
      ),
    ),
    indexedAt: l.optional(l.string({ format: 'datetime' })),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    viewer: l.optional(l.ref<ViewerState>((() => viewerState) as any)),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    pinnedPost: l.optional(
      l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
    ),
    verification: l.optional(
      l.ref<VerificationState>((() => verificationState) as any),
    ),
    status: l.optional(l.ref<StatusView>((() => statusView) as any)),
    debug: l.optional(l.lexMap()),
  }),
)

export { profileViewDetailed }

type ProfileAssociated = {
  $type?: 'app.bsky.actor.defs#profileAssociated'
  lists?: number
  feedgens?: number
  starterPacks?: number
  labeler?: boolean
  chat?: ProfileAssociatedChat
  activitySubscription?: ProfileAssociatedActivitySubscription
  germ?: ProfileAssociatedGerm
}

export type { ProfileAssociated }

const profileAssociated = l.typedObject<ProfileAssociated>(
  $nsid,
  'profileAssociated',
  l.object({
    lists: l.optional(l.integer()),
    feedgens: l.optional(l.integer()),
    starterPacks: l.optional(l.integer()),
    labeler: l.optional(l.boolean()),
    chat: l.optional(
      l.ref<ProfileAssociatedChat>((() => profileAssociatedChat) as any),
    ),
    activitySubscription: l.optional(
      l.ref<ProfileAssociatedActivitySubscription>(
        (() => profileAssociatedActivitySubscription) as any,
      ),
    ),
    germ: l.optional(
      l.ref<ProfileAssociatedGerm>((() => profileAssociatedGerm) as any),
    ),
  }),
)

export { profileAssociated }

type ProfileAssociatedChat = {
  $type?: 'app.bsky.actor.defs#profileAssociatedChat'
  allowIncoming: 'all' | 'none' | 'following' | l.UnknownString
}

export type { ProfileAssociatedChat }

const profileAssociatedChat = l.typedObject<ProfileAssociatedChat>(
  $nsid,
  'profileAssociatedChat',
  l.object({
    allowIncoming: l.string<{ knownValues: ['all', 'none', 'following'] }>(),
  }),
)

export { profileAssociatedChat }

type ProfileAssociatedGerm = {
  $type?: 'app.bsky.actor.defs#profileAssociatedGerm'
  messageMeUrl: l.UriString
  showButtonTo: 'usersIFollow' | 'everyone' | l.UnknownString
}

export type { ProfileAssociatedGerm }

const profileAssociatedGerm = l.typedObject<ProfileAssociatedGerm>(
  $nsid,
  'profileAssociatedGerm',
  l.object({
    messageMeUrl: l.string({ format: 'uri' }),
    showButtonTo: l.string<{ knownValues: ['usersIFollow', 'everyone'] }>(),
  }),
)

export { profileAssociatedGerm }

type ProfileAssociatedActivitySubscription = {
  $type?: 'app.bsky.actor.defs#profileAssociatedActivitySubscription'
  allowSubscriptions: 'followers' | 'mutuals' | 'none' | l.UnknownString
}

export type { ProfileAssociatedActivitySubscription }

const profileAssociatedActivitySubscription =
  l.typedObject<ProfileAssociatedActivitySubscription>(
    $nsid,
    'profileAssociatedActivitySubscription',
    l.object({
      allowSubscriptions: l.string<{
        knownValues: ['followers', 'mutuals', 'none']
      }>(),
    }),
  )

export { profileAssociatedActivitySubscription }

/** Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests. */
type ViewerState = {
  $type?: 'app.bsky.actor.defs#viewerState'
  muted?: boolean
  mutedByList?: GraphDefs.ListViewBasic
  blockedBy?: boolean
  blocking?: l.AtUriString
  blockingByList?: GraphDefs.ListViewBasic
  following?: l.AtUriString
  followedBy?: l.AtUriString

  /**
   * This property is present only in selected cases, as an optimization.
   */
  knownFollowers?: KnownFollowers

  /**
   * This property is present only in selected cases, as an optimization.
   */
  activitySubscription?: NotificationDefs.ActivitySubscription
}

export type { ViewerState }

/** Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests. */
const viewerState = l.typedObject<ViewerState>(
  $nsid,
  'viewerState',
  l.object({
    muted: l.optional(l.boolean()),
    mutedByList: l.optional(
      l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any),
    ),
    blockedBy: l.optional(l.boolean()),
    blocking: l.optional(l.string({ format: 'at-uri' })),
    blockingByList: l.optional(
      l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any),
    ),
    following: l.optional(l.string({ format: 'at-uri' })),
    followedBy: l.optional(l.string({ format: 'at-uri' })),
    knownFollowers: l.optional(
      l.ref<KnownFollowers>((() => knownFollowers) as any),
    ),
    activitySubscription: l.optional(
      l.ref<NotificationDefs.ActivitySubscription>(
        (() => NotificationDefs.activitySubscription) as any,
      ),
    ),
  }),
)

export { viewerState }

/** The subject's followers whom you also follow */
type KnownFollowers = {
  $type?: 'app.bsky.actor.defs#knownFollowers'
  count: number
  followers: ProfileViewBasic[]
}

export type { KnownFollowers }

/** The subject's followers whom you also follow */
const knownFollowers = l.typedObject<KnownFollowers>(
  $nsid,
  'knownFollowers',
  l.object({
    count: l.integer(),
    followers: l.array(
      l.ref<ProfileViewBasic>((() => profileViewBasic) as any),
      { minLength: 0, maxLength: 5 },
    ),
  }),
)

export { knownFollowers }

/** Represents the verification information about the user this object is attached to. */
type VerificationState = {
  $type?: 'app.bsky.actor.defs#verificationState'

  /**
   * All verifications issued by trusted verifiers on behalf of this user. Verifications by untrusted verifiers are not included.
   */
  verifications: VerificationView[]

  /**
   * The user's status as a verified account.
   */
  verifiedStatus: 'valid' | 'invalid' | 'none' | l.UnknownString

  /**
   * The user's status as a trusted verifier.
   */
  trustedVerifierStatus: 'valid' | 'invalid' | 'none' | l.UnknownString
}

export type { VerificationState }

/** Represents the verification information about the user this object is attached to. */
const verificationState = l.typedObject<VerificationState>(
  $nsid,
  'verificationState',
  l.object({
    verifications: l.array(
      l.ref<VerificationView>((() => verificationView) as any),
    ),
    verifiedStatus: l.string<{ knownValues: ['valid', 'invalid', 'none'] }>(),
    trustedVerifierStatus: l.string<{
      knownValues: ['valid', 'invalid', 'none']
    }>(),
  }),
)

export { verificationState }

/** An individual verification for an associated subject. */
type VerificationView = {
  $type?: 'app.bsky.actor.defs#verificationView'

  /**
   * The user who issued this verification.
   */
  issuer: l.DidString

  /**
   * The AT-URI of the verification record.
   */
  uri: l.AtUriString

  /**
   * True if the verification passes validation, otherwise false.
   */
  isValid: boolean

  /**
   * Timestamp when the verification was created.
   */
  createdAt: l.DatetimeString
}

export type { VerificationView }

/** An individual verification for an associated subject. */
const verificationView = l.typedObject<VerificationView>(
  $nsid,
  'verificationView',
  l.object({
    issuer: l.string({ format: 'did' }),
    uri: l.string({ format: 'at-uri' }),
    isValid: l.boolean(),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { verificationView }

type Preferences = (
  | l.$Typed<AdultContentPref>
  | l.$Typed<ContentLabelPref>
  | l.$Typed<SavedFeedsPref>
  | l.$Typed<SavedFeedsPrefV2>
  | l.$Typed<PersonalDetailsPref>
  | l.$Typed<DeclaredAgePref>
  | l.$Typed<FeedViewPref>
  | l.$Typed<ThreadViewPref>
  | l.$Typed<InterestsPref>
  | l.$Typed<MutedWordsPref>
  | l.$Typed<HiddenPostsPref>
  | l.$Typed<BskyAppStatePref>
  | l.$Typed<LabelersPref>
  | l.$Typed<PostInteractionSettingsPref>
  | l.$Typed<VerificationPrefs>
  | l.$Typed<LiveEventPreferences>
  | l.Unknown$TypedObject
)[]

export type { Preferences }

const preferences = l.array<Preferences[number]>(
  l.typedUnion(
    [
      l.typedRef<AdultContentPref>((() => adultContentPref) as any),
      l.typedRef<ContentLabelPref>((() => contentLabelPref) as any),
      l.typedRef<SavedFeedsPref>((() => savedFeedsPref) as any),
      l.typedRef<SavedFeedsPrefV2>((() => savedFeedsPrefV2) as any),
      l.typedRef<PersonalDetailsPref>((() => personalDetailsPref) as any),
      l.typedRef<DeclaredAgePref>((() => declaredAgePref) as any),
      l.typedRef<FeedViewPref>((() => feedViewPref) as any),
      l.typedRef<ThreadViewPref>((() => threadViewPref) as any),
      l.typedRef<InterestsPref>((() => interestsPref) as any),
      l.typedRef<MutedWordsPref>((() => mutedWordsPref) as any),
      l.typedRef<HiddenPostsPref>((() => hiddenPostsPref) as any),
      l.typedRef<BskyAppStatePref>((() => bskyAppStatePref) as any),
      l.typedRef<LabelersPref>((() => labelersPref) as any),
      l.typedRef<PostInteractionSettingsPref>(
        (() => postInteractionSettingsPref) as any,
      ),
      l.typedRef<VerificationPrefs>((() => verificationPrefs) as any),
      l.typedRef<LiveEventPreferences>((() => liveEventPreferences) as any),
    ],
    false,
  ),
)

export { preferences }

type AdultContentPref = {
  $type?: 'app.bsky.actor.defs#adultContentPref'
  enabled: boolean
}

export type { AdultContentPref }

const adultContentPref = l.typedObject<AdultContentPref>(
  $nsid,
  'adultContentPref',
  l.object({ enabled: l.withDefault(l.boolean(), false) }),
)

export { adultContentPref }

type ContentLabelPref = {
  $type?: 'app.bsky.actor.defs#contentLabelPref'

  /**
   * Which labeler does this preference apply to? If undefined, applies globally.
   */
  labelerDid?: l.DidString
  label: string
  visibility: 'ignore' | 'show' | 'warn' | 'hide' | l.UnknownString
}

export type { ContentLabelPref }

const contentLabelPref = l.typedObject<ContentLabelPref>(
  $nsid,
  'contentLabelPref',
  l.object({
    labelerDid: l.optional(l.string({ format: 'did' })),
    label: l.string(),
    visibility: l.string<{ knownValues: ['ignore', 'show', 'warn', 'hide'] }>(),
  }),
)

export { contentLabelPref }

type SavedFeed = {
  $type?: 'app.bsky.actor.defs#savedFeed'
  id: string
  type: 'feed' | 'list' | 'timeline' | l.UnknownString
  value: string
  pinned: boolean
}

export type { SavedFeed }

const savedFeed = l.typedObject<SavedFeed>(
  $nsid,
  'savedFeed',
  l.object({
    id: l.string(),
    type: l.string<{ knownValues: ['feed', 'list', 'timeline'] }>(),
    value: l.string(),
    pinned: l.boolean(),
  }),
)

export { savedFeed }

type SavedFeedsPrefV2 = {
  $type?: 'app.bsky.actor.defs#savedFeedsPrefV2'
  items: SavedFeed[]
}

export type { SavedFeedsPrefV2 }

const savedFeedsPrefV2 = l.typedObject<SavedFeedsPrefV2>(
  $nsid,
  'savedFeedsPrefV2',
  l.object({ items: l.array(l.ref<SavedFeed>((() => savedFeed) as any)) }),
)

export { savedFeedsPrefV2 }

type SavedFeedsPref = {
  $type?: 'app.bsky.actor.defs#savedFeedsPref'
  pinned: l.AtUriString[]
  saved: l.AtUriString[]
  timelineIndex?: number
}

export type { SavedFeedsPref }

const savedFeedsPref = l.typedObject<SavedFeedsPref>(
  $nsid,
  'savedFeedsPref',
  l.object({
    pinned: l.array(l.string({ format: 'at-uri' })),
    saved: l.array(l.string({ format: 'at-uri' })),
    timelineIndex: l.optional(l.integer()),
  }),
)

export { savedFeedsPref }

type PersonalDetailsPref = {
  $type?: 'app.bsky.actor.defs#personalDetailsPref'

  /**
   * The birth date of account owner.
   */
  birthDate?: l.DatetimeString
}

export type { PersonalDetailsPref }

const personalDetailsPref = l.typedObject<PersonalDetailsPref>(
  $nsid,
  'personalDetailsPref',
  l.object({ birthDate: l.optional(l.string({ format: 'datetime' })) }),
)

export { personalDetailsPref }

/** Read-only preference containing value(s) inferred from the user's declared birthdate. Absence of this preference object in the response indicates that the user has not made a declaration. */
type DeclaredAgePref = {
  $type?: 'app.bsky.actor.defs#declaredAgePref'

  /**
   * Indicates if the user has declared that they are over 13 years of age.
   */
  isOverAge13?: boolean

  /**
   * Indicates if the user has declared that they are over 16 years of age.
   */
  isOverAge16?: boolean

  /**
   * Indicates if the user has declared that they are over 18 years of age.
   */
  isOverAge18?: boolean
}

export type { DeclaredAgePref }

/** Read-only preference containing value(s) inferred from the user's declared birthdate. Absence of this preference object in the response indicates that the user has not made a declaration. */
const declaredAgePref = l.typedObject<DeclaredAgePref>(
  $nsid,
  'declaredAgePref',
  l.object({
    isOverAge13: l.optional(l.boolean()),
    isOverAge16: l.optional(l.boolean()),
    isOverAge18: l.optional(l.boolean()),
  }),
)

export { declaredAgePref }

type FeedViewPref = {
  $type?: 'app.bsky.actor.defs#feedViewPref'

  /**
   * The URI of the feed, or an identifier which describes the feed.
   */
  feed: string

  /**
   * Hide replies in the feed.
   */
  hideReplies?: boolean

  /**
   * Hide replies in the feed if they are not by followed users.
   */
  hideRepliesByUnfollowed?: boolean

  /**
   * Hide replies in the feed if they do not have this number of likes.
   */
  hideRepliesByLikeCount?: number

  /**
   * Hide reposts in the feed.
   */
  hideReposts?: boolean

  /**
   * Hide quote posts in the feed.
   */
  hideQuotePosts?: boolean
}

export type { FeedViewPref }

const feedViewPref = l.typedObject<FeedViewPref>(
  $nsid,
  'feedViewPref',
  l.object({
    feed: l.string(),
    hideReplies: l.optional(l.boolean()),
    hideRepliesByUnfollowed: l.optional(l.withDefault(l.boolean(), true)),
    hideRepliesByLikeCount: l.optional(l.integer()),
    hideReposts: l.optional(l.boolean()),
    hideQuotePosts: l.optional(l.boolean()),
  }),
)

export { feedViewPref }

type ThreadViewPref = {
  $type?: 'app.bsky.actor.defs#threadViewPref'

  /**
   * Sorting mode for threads.
   */
  sort?:
    | 'oldest'
    | 'newest'
    | 'most-likes'
    | 'random'
    | 'hotness'
    | l.UnknownString
}

export type { ThreadViewPref }

const threadViewPref = l.typedObject<ThreadViewPref>(
  $nsid,
  'threadViewPref',
  l.object({
    sort: l.optional(
      l.string<{
        knownValues: ['oldest', 'newest', 'most-likes', 'random', 'hotness']
      }>(),
    ),
  }),
)

export { threadViewPref }

type InterestsPref = {
  $type?: 'app.bsky.actor.defs#interestsPref'

  /**
   * A list of tags which describe the account owner's interests gathered during onboarding.
   */
  tags: string[]
}

export type { InterestsPref }

const interestsPref = l.typedObject<InterestsPref>(
  $nsid,
  'interestsPref',
  l.object({
    tags: l.array(l.string({ maxLength: 640, maxGraphemes: 64 }), {
      maxLength: 100,
    }),
  }),
)

export { interestsPref }

type MutedWordTarget = 'content' | 'tag' | l.UnknownString

export type { MutedWordTarget }

const mutedWordTarget = l.string<{
  knownValues: ['content', 'tag']
  maxLength: 640
  maxGraphemes: 64
}>({ maxLength: 640, maxGraphemes: 64 })

export { mutedWordTarget }

/** A word that the account owner has muted. */
type MutedWord = {
  $type?: 'app.bsky.actor.defs#mutedWord'
  id?: string

  /**
   * The muted word itself.
   */
  value: string

  /**
   * The intended targets of the muted word.
   */
  targets: MutedWordTarget[]

  /**
   * Groups of users to apply the muted word to. If undefined, applies to all users.
   */
  actorTarget?: 'all' | 'exclude-following' | l.UnknownString

  /**
   * The date and time at which the muted word will expire and no longer be applied.
   */
  expiresAt?: l.DatetimeString
}

export type { MutedWord }

/** A word that the account owner has muted. */
const mutedWord = l.typedObject<MutedWord>(
  $nsid,
  'mutedWord',
  l.object({
    id: l.optional(l.string()),
    value: l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    targets: l.array(l.ref<MutedWordTarget>((() => mutedWordTarget) as any)),
    actorTarget: l.optional(
      l.withDefault(
        l.string<{ knownValues: ['all', 'exclude-following'] }>(),
        'all',
      ),
    ),
    expiresAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { mutedWord }

type MutedWordsPref = {
  $type?: 'app.bsky.actor.defs#mutedWordsPref'

  /**
   * A list of words the account owner has muted.
   */
  items: MutedWord[]
}

export type { MutedWordsPref }

const mutedWordsPref = l.typedObject<MutedWordsPref>(
  $nsid,
  'mutedWordsPref',
  l.object({ items: l.array(l.ref<MutedWord>((() => mutedWord) as any)) }),
)

export { mutedWordsPref }

type HiddenPostsPref = {
  $type?: 'app.bsky.actor.defs#hiddenPostsPref'

  /**
   * A list of URIs of posts the account owner has hidden.
   */
  items: l.AtUriString[]
}

export type { HiddenPostsPref }

const hiddenPostsPref = l.typedObject<HiddenPostsPref>(
  $nsid,
  'hiddenPostsPref',
  l.object({ items: l.array(l.string({ format: 'at-uri' })) }),
)

export { hiddenPostsPref }

type LabelersPref = {
  $type?: 'app.bsky.actor.defs#labelersPref'
  labelers: LabelerPrefItem[]
}

export type { LabelersPref }

const labelersPref = l.typedObject<LabelersPref>(
  $nsid,
  'labelersPref',
  l.object({
    labelers: l.array(l.ref<LabelerPrefItem>((() => labelerPrefItem) as any)),
  }),
)

export { labelersPref }

type LabelerPrefItem = {
  $type?: 'app.bsky.actor.defs#labelerPrefItem'
  did: l.DidString
}

export type { LabelerPrefItem }

const labelerPrefItem = l.typedObject<LabelerPrefItem>(
  $nsid,
  'labelerPrefItem',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { labelerPrefItem }

/** A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this. */
type BskyAppStatePref = {
  $type?: 'app.bsky.actor.defs#bskyAppStatePref'
  activeProgressGuide?: BskyAppProgressGuide

  /**
   * An array of tokens which identify nudges (modals, popups, tours, highlight dots) that should be shown to the user.
   */
  queuedNudges?: string[]

  /**
   * Storage for NUXs the user has encountered.
   */
  nuxs?: Nux[]
}

export type { BskyAppStatePref }

/** A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this. */
const bskyAppStatePref = l.typedObject<BskyAppStatePref>(
  $nsid,
  'bskyAppStatePref',
  l.object({
    activeProgressGuide: l.optional(
      l.ref<BskyAppProgressGuide>((() => bskyAppProgressGuide) as any),
    ),
    queuedNudges: l.optional(
      l.array(l.string({ maxLength: 100 }), { maxLength: 1000 }),
    ),
    nuxs: l.optional(
      l.array(l.ref<Nux>((() => nux) as any), { maxLength: 100 }),
    ),
  }),
)

export { bskyAppStatePref }

/** If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress. */
type BskyAppProgressGuide = {
  $type?: 'app.bsky.actor.defs#bskyAppProgressGuide'
  guide: string
}

export type { BskyAppProgressGuide }

/** If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress. */
const bskyAppProgressGuide = l.typedObject<BskyAppProgressGuide>(
  $nsid,
  'bskyAppProgressGuide',
  l.object({ guide: l.string({ maxLength: 100 }) }),
)

export { bskyAppProgressGuide }

/** A new user experiences (NUX) storage object */
type Nux = {
  $type?: 'app.bsky.actor.defs#nux'
  id: string
  completed: boolean

  /**
   * Arbitrary data for the NUX. The structure is defined by the NUX itself. Limited to 300 characters.
   */
  data?: string

  /**
   * The date and time at which the NUX will expire and should be considered completed.
   */
  expiresAt?: l.DatetimeString
}

export type { Nux }

/** A new user experiences (NUX) storage object */
const nux = l.typedObject<Nux>(
  $nsid,
  'nux',
  l.object({
    id: l.string({ maxLength: 100 }),
    completed: l.withDefault(l.boolean(), false),
    data: l.optional(l.string({ maxLength: 3000, maxGraphemes: 300 })),
    expiresAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { nux }

/** Preferences for how verified accounts appear in the app. */
type VerificationPrefs = {
  $type?: 'app.bsky.actor.defs#verificationPrefs'

  /**
   * Hide the blue check badges for verified accounts and trusted verifiers.
   */
  hideBadges?: boolean
}

export type { VerificationPrefs }

/** Preferences for how verified accounts appear in the app. */
const verificationPrefs = l.typedObject<VerificationPrefs>(
  $nsid,
  'verificationPrefs',
  l.object({ hideBadges: l.optional(l.withDefault(l.boolean(), false)) }),
)

export { verificationPrefs }

/** Preferences for live events. */
type LiveEventPreferences = {
  $type?: 'app.bsky.actor.defs#liveEventPreferences'

  /**
   * A list of feed IDs that the user has hidden from live events.
   */
  hiddenFeedIds?: string[]

  /**
   * Whether to hide all feeds from live events.
   */
  hideAllFeeds?: boolean
}

export type { LiveEventPreferences }

/** Preferences for live events. */
const liveEventPreferences = l.typedObject<LiveEventPreferences>(
  $nsid,
  'liveEventPreferences',
  l.object({
    hiddenFeedIds: l.optional(l.array(l.string())),
    hideAllFeeds: l.optional(l.withDefault(l.boolean(), false)),
  }),
)

export { liveEventPreferences }

/** Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly. */
type PostInteractionSettingsPref = {
  $type?: 'app.bsky.actor.defs#postInteractionSettingsPref'

  /**
   * Matches threadgate record. List of rules defining who can reply to this users posts. If value is an empty array, no one can reply. If value is undefined, anyone can reply.
   */
  threadgateAllowRules?: (
    | l.$Typed<FeedThreadgate.MentionRule>
    | l.$Typed<FeedThreadgate.FollowerRule>
    | l.$Typed<FeedThreadgate.FollowingRule>
    | l.$Typed<FeedThreadgate.ListRule>
    | l.Unknown$TypedObject
  )[]

  /**
   * Matches postgate record. List of rules defining who can embed this users posts. If value is an empty array or is undefined, no particular rules apply and anyone can embed.
   */
  postgateEmbeddingRules?: (
    | l.$Typed<FeedPostgate.DisableRule>
    | l.Unknown$TypedObject
  )[]
}

export type { PostInteractionSettingsPref }

/** Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly. */
const postInteractionSettingsPref = l.typedObject<PostInteractionSettingsPref>(
  $nsid,
  'postInteractionSettingsPref',
  l.object({
    threadgateAllowRules: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<FeedThreadgate.MentionRule>(
              (() => FeedThreadgate.mentionRule) as any,
            ),
            l.typedRef<FeedThreadgate.FollowerRule>(
              (() => FeedThreadgate.followerRule) as any,
            ),
            l.typedRef<FeedThreadgate.FollowingRule>(
              (() => FeedThreadgate.followingRule) as any,
            ),
            l.typedRef<FeedThreadgate.ListRule>(
              (() => FeedThreadgate.listRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
    postgateEmbeddingRules: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<FeedPostgate.DisableRule>(
              (() => FeedPostgate.disableRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
  }),
)

export { postInteractionSettingsPref }

type StatusView = {
  $type?: 'app.bsky.actor.defs#statusView'
  uri?: l.AtUriString
  cid?: l.CidString

  /**
   * The status for the account.
   */
  status: 'app.bsky.actor.status#live' | l.UnknownString
  record: l.LexMap

  /**
   * An optional embed associated with the status.
   */
  embed?: l.$Typed<EmbedExternal.View> | l.Unknown$TypedObject
  labels?: LabelDefs.Label[]

  /**
   * The date when this status will expire. The application might choose to no longer return the status after expiration.
   */
  expiresAt?: l.DatetimeString

  /**
   * True if the status is not expired, false if it is expired. Only present if expiration was set.
   */
  isActive?: boolean

  /**
   * True if the user's go-live access has been disabled by a moderator, false otherwise.
   */
  isDisabled?: boolean
}

export type { StatusView }

const statusView = l.typedObject<StatusView>(
  $nsid,
  'statusView',
  l.object({
    uri: l.optional(l.string({ format: 'at-uri' })),
    cid: l.optional(l.string({ format: 'cid' })),
    status: l.string<{ knownValues: ['app.bsky.actor.status#live'] }>(),
    record: l.lexMap(),
    embed: l.optional(
      l.typedUnion(
        [l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any)],
        false,
      ),
    ),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    expiresAt: l.optional(l.string({ format: 'datetime' })),
    isActive: l.optional(l.boolean()),
    isDisabled: l.optional(l.boolean()),
  }),
)

export { statusView }
